import React, { useEffect } from 'react';
import MarkdownRenderer from '../MarkdownRenderer/MarkdownRenderer';
import './ArticleContent.css';

const ArticleContent = ({
  content,
  onHeadingsExtract,
  images = null,
  forceInlineImages = false,
  disableCarousel = false,
  enableContiguousImageGrid = false
}) => {
  const displayText = String(content || '');

  useEffect(() => {
    // Extract headings for TOC
    if (!displayText || !onHeadingsExtract) return;

    const headingRegex = /^(#{1,6})\s+(.+)$/gm;
    const matches = [];
    let match;

    while ((match = headingRegex.exec(displayText)) !== null) {
      const level = match[1].length;
      const text = match[2].trim();
      matches.push({ level, text });
    }

    onHeadingsExtract(matches);
  }, [displayText, onHeadingsExtract]);

  return (
    <article className="article-content">
      <div className="article-body">
        <MarkdownRenderer
          content={displayText}
          images={images}
          forceInlineImages={forceInlineImages}
          disableCarousel={disableCarousel}
          enableContiguousImageGrid={enableContiguousImageGrid}
        />
      </div>
    </article>
  );
};

export default ArticleContent;
